/**
 * Reads and exports the routes as defined by each resource module.
 *
 * NOTE: this facilitates adding routes via the CLI. The CLI will automatically
 * build these exports with the camelCase version of the resource name so as to
 * add a consistent top-level path to the resource. A resource named UserWorkout
 * will show below as follows:
 *
 * export { default as userWorkout } from './userWorkout/UserWorkoutRouter.js.jsx'
 *
 * This will give it a top-level route path called 'user-workouts'
 */

export { default as admin } from  './admin/AdminRouter.js.jsx';
export { default as cmBuilder } from './contentModule/ContentModuleBuildRouter.js.jsx';
export { default as user } from './user/UserRouter.js.jsx';
export { default as products } from './product/ProductRouter.js.jsx';

export { default as nodes } from './node/NodeRouter.js.jsx';
export { default as transitions } from './transition/TransitionRouter.js.jsx';
export { default as scenes } from './scene/SceneRouter.js.jsx';
// export { default as courses } from './course/CourseRouter.js.jsx';
// export { default as contactUs } from './static/StaticRouter.js.jsx'; // updated so we can get /contact-us
export { default as sponsors } from './sponsor/SponsorRouter.js.jsx';
export { default as studiesDashboard } from './study/StudiesDashboardRouter.js.jsx';
export { default as userNodes } from './userNode/UserNodeRouter.js.jsx';
export { default as userModules } from './userModule/UserModuleRouter.js.jsx';
export { default as evaluations } from './evaluation/EvaluationRouter.js.jsx';
export { default as questions } from './question/QuestionRouter.js.jsx';
export { default as answers } from './answer/AnswerRouter.js.jsx';
export { default as userEvaluations } from './userEvaluation/UserEvaluationRouter.js.jsx';
export { default as userAnswers } from './userAnswer/UserAnswerRouter.js.jsx';
export { default as userProfiles } from './userProfile/UserProfileRouter.js.jsx'; 

export { default as moduleCertificates } from './moduleCertificate/ModuleCertificateRouter.js.jsx';
export { default as courseCertificates } from './courseCertificate/CourseCertificateRouter.js.jsx';
export { default as certificateTemplates } from './certificateTemplate/CertificateTemplateRouter.js.jsx';
export { default as siteLocations } from './siteLocation/SiteLocationRouter.js.jsx';
export { default as auditLogs } from './auditLog/AuditLogRouter.js.jsx';

// user "my-*" routes
export { default as myAgenda } from './agenda/MyAgendaRouter.js.jsx'; // updated so we can get /my-studies
export { default as myCertificates } from './user/MyCertificatesRouter.js.jsx'; // updated so we can get /my-studies
// export { default as myStudies } from './user/MyStudiesRouter.js.jsx'; // updated so we can get /my-studies



// WEBPACK FOOTER //
// modules/moduleRoutes.js